import { render, staticRenderFns } from "./CoHeadline.vue?vue&type=template&id=1bbfb24a&scoped=true&"
import script from "./CoHeadline.vue?vue&type=script&lang=ts&"
export * from "./CoHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./CoHeadline.vue?vue&type=style&index=0&id=1bbfb24a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfb24a",
  null
  
)

export default component.exports